import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layout Components
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";

// Pages
import { Home } from "./pages/Home";
import { Features } from "./pages/Features";
import { UseCases } from "./pages/UseCases";
import { Pricing } from "./pages/Pricing";
import { Security } from "./pages/Security";
import { About } from "./pages/About";
import { Demo } from "./pages/Demo";
import { ScrollToTop } from "./components/ui/ScrollToTop";
import ScrollToHash from "./components/ui/ScrollToHash";
import PromoModal from "./components/ui/PromoModal";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToHash />
        {/* <PromoModal /> */}
        <Navbar />
        <main className="flex-1">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/features" element={<Features />} /> */}
            <Route path="/Who-We-Serve" element={<UseCases />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/security" element={<Security />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact-us" element={<Demo />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
